<template>
    <div class="container">
        <o-bread-crumb>
            <template v-slot:pageName>
                Corporate
            </template>
            <template v-slot:pageDetail>
                List
            </template>
            <template v-slot:pageDescription>
               
                <br>
               
            </template>
        </o-bread-crumb>
        <div class="card text-center">
            <div class="card-header">
                <ul class="nav nav-pills card-header-pills justify-content-between ms-2 me-4 mt-2 mb-2">
                    <li class="nav-item">
                        <div class="d-flex d-inline-block">
                            <a class="nav-link text-dark fs-4" href="#">List of Corporates</a>
                        </div>
                    </li>
                    <li class="nav-item btn btn-primary btn-sm">
                        <router-link :to="{ name: 'CorporateForm' }" class="nav-link text-white">Add new corporate
                        </router-link>
                    </li>
                </ul>
            </div>
            <div class="card-body">
            <div class="d-flex justify-content-center spinner-border text-primary spinner-position" v-if="page.isLoading"></div>
            <div class="spinner" v-if='page.isLoading'></div>
            <div class="" v-if="page.output">
                <ul class="nav nav-pills card-header-pills justify-content-between ms-2 me-4 mt-2 mb-2">
                    <li class="nav-item">
                        <div class="d-flex d-inline-block">                                
                            <o-search :searchOptions="searchOptions" @submit="search" @clear="clearSearch"></o-search>
                        </div>
                    </li>
                    <li class="nav-item btn btn-primary btn-sm">
                        <button class="reload nav-link text-white" @click.prevent="load_state()">&#x21bb;</button>
                    </li>
                </ul>
                <o-table style="text-align:left;" class="table-hover">
                    <thead>
                        <tr v-if="fields">
                            <td class="fw-bolder text-muted" style="width: 100px" scope="col" v-for="(field, index) in fields" :key="index">
                                {{ field }}
                            </td>
                        </tr>
                    </thead>
                    <tbody>
                            <tr v-for="(item, index) in corporates" :key="index">
                            <td>{{ (meta.page - 1) * meta.limit + index + 1 }}</td>
                            <td>{{ item.code }}</td>
                            <td>{{ item.slug_name }}</td>
                            <td>{{ item.name }}</td>
                            <td class="ml-3">
                                <div class="d-flex">
                                    <div class="me-1">
                                        <button class="btn btn-sm btn-success rounded-pill text-white" @click="editModal(item.id, item.link_direct)">
                                            Create Link
                                        </button>
                                    </div>
                                    <div class="me-1">
                                        <button class="btn btn-sm btn-info rounded-pill text-white">
                                            <router-link class="text-white" :to="{ name: 'CorporateForm.edit', params: { id: item.id } }">Edit
                                            </router-link>
                                        </button>
                                    </div>
                                    <div>
                                        <button class="btn btn-sm btn-danger rounded-pill text-white" @click.prevent="confirmDelete(item)">
                                            Delete
                                        </button>
                                    </div>
                                </div>
                            </td>
                    </tr>
                    <tr v-if="corporates.length === 0">
                        <td colspan="5" class="text-center">No corporates available</td>
                    </tr>
                    </tbody>
                </o-table>
            </div>
            </div>
            <!-- <input type="text" name="" id="" v-model="navPage"> -->

            <div class="container mt-5">
                <o-pagination :page="meta.page"  :total="meta.total" @callback="navPage"/>
            </div>
        </div>
        <o-warning-box
            v-if="isDeleteConfirmVisible"
            title="Delete Corporate"
            :item-name="itemToDelete?.name || 'this corporate'"
            warning-message="This action cannot be undone."
            confirm-text="Yes, Delete"
            cancel-text="Cancel"
            :is-loading="page.isLoading"
            @confirm="handleDelete"
            @cancel="closeDeleteConfirm"
        />
    </div>
    <br>
    <corporate-detail
        v-if="isModalVisible"
        @parentAddItem="saveDetail"
        @parentCloseModal="closeModal"
        :editedItem="editedItem">
    </corporate-detail>
</template>

<script>

import store from '@/store/'
import {mapState} from 'vuex'
import {OTable, 
OPagination,
OBreadCrumb,
OSearch,
OWarningBox
} from '@/components/OmnihControl'
// import axios from 'axios'
import { 
    computed, 
    onMounted, reactive, ref,
    onBeforeUnmount,
} from 'vue'
import { useRoute, useRouter } from 'vue-router'
import CorporateDetail from './corporate/CorporateDetail.vue';

export default {
    setup() {
        const route = useRoute();
        const router = useRouter();
        let lastActivePage = 1;

        const page = reactive({
            isLoading: false,
            output: false
        });

        let fields = ref([
            'No',
            'Code',
            'Slug Name',
            'Corporate Name',
            'Actions'
        ]);

        const corporatesSearch = ref([]);

        const selectCorporate = ref();

        const searchBy = reactive({
            selected:"code",
            criteria:""
        })

        const searchOptions = reactive([
            { value: 'code', text: 'code' },
            { value: 'name', text: 'corporate name' },
        ]);

        const isModalVisible = ref(false);
        const error = ref(null);
        const editedItem = ref({
            id: '',
            direct_link: '',
            title: ''
        });

        function showModal() {
            editedItem.value = {};
            isModalVisible.value = true;
        }

        function closeModal() {
            isModalVisible.value = false;
        }

        function editModal(id, direct) {      
            editedItem.value = {
                id: id,
                direct_link: direct,
                title: 'Edit Value'
            };            
            isModalVisible.value = true;
        }

        function saveDetail(dataDariChild) {
            page.isLoading = true;

            store.dispatch('Auth/getBusinessProfile').then((businessProfile) => {
                dataDariChild.corporate_id = businessProfile.corporate_id;

                store.dispatch('Corporate/update', { data: dataDariChild })
                    .then(() => {
                    load_state();
                    })
                    .catch((err) => {
                    if(err.response && err.response.status === 403){
                        error.value = err.response.data.message
                    }else{
                        error.value = "Please input min transaction value with 9 digit not more."
                    }
                    console.error('Error updating Member Tier:', err);
                    })
                    .finally(() => {
                    page.isLoading = false;
                    isModalVisible.value = false;
                });
            }).catch((err) => {
                console.error('Error fetching business profile:', err);
                page.isLoading = false;
                isModalVisible.value = false;
            }).finally(() => {
                isModalVisible.value = false;
            });
        }

        let meta = computed(() => store.state.Corporate.meta)

        onMounted(() => {
            store.commit('Corporate/reset_meta');

            load_state();

            // Check if redirected from create corporate page
            if (route.query.newCorporate === 'true') {
                store.dispatch('Corporate/read').then(() => {
                    const lastPage = meta.value.total;
                    if (lastPage > 1 && meta.value.page !== lastPage) {
                        const newMeta = { ...meta.value, page: lastPage };
                        store.commit('Corporate/switch_page', { meta: newMeta });
                        store.dispatch('Corporate/read');
                    }
                    router.replace({ name: 'Corporate' });
                });
            }
        });

        onBeforeUnmount(() => {
            const updatedMeta = { ...meta.value, page: lastActivePage };
            store.commit('Corporate/switch_page', { meta: updatedMeta });

            store.commit('Corporate/clear_search');
            store.dispatch('Corporate/read').then(() => {});
        });

        function load_state(){
            page.isLoading = true;

            console.log('send request');
            
            store.dispatch('Corporate/read')
            .then()
            .catch((err) => console.error(err))
            .finally(()=>{
                page.isLoading = false;search
                page.output=true;

            });
        }

        const isDeleteConfirmVisible = ref(false)
        const itemToDelete = ref(null)

        const confirmDelete = (item) => {
            itemToDelete.value = item
            isDeleteConfirmVisible.value = true
        }

        const closeDeleteConfirm = () => {
            isDeleteConfirmVisible.value = false
            itemToDelete.value = null
        }

        const handleDelete = () => {
            if (!itemToDelete.value) return

            page.isLoading = true

            store.dispatch('Corporate/delete', itemToDelete.value.id)
            .then(() => {
                load_state();
            }).catch((err) => {
                console.log(err.response.data);
            }).finally(() => {
                page.isLoading = false;
                closeDeleteConfirm();
            });
        }

        function navPage(page){
            const _meta = {... meta.value, page}

            console.log({page});
            console.log({_meta});
            store.commit('Corporate/switch_page',{meta:_meta})
            load_state()
        }

        function search(searchBy){
            const {selected, criteria} = searchBy;

            if (selected && criteria) {
                let search = {};
                search[selected] = criteria;
    
                const updatedMeta = { ...meta.value, page: 1 };
                store.commit('Corporate/switch_page', { meta: updatedMeta });

                store.commit('Corporate/set_search', { search });
                store.dispatch('Corporate/read').then(() => {});
            }
        }

        function clearSearch(){
            const updatedMeta = { ...meta.value, page: lastActivePage };
            store.commit('Corporate/switch_page', { meta: updatedMeta });

            store.commit('Corporate/clear_search');
            store.dispatch('Corporate/read').then(() => {});
        }

        return {
            meta,
            page,
            confirmDelete,
            handleDelete,
            closeDeleteConfirm,
            isDeleteConfirmVisible,
            itemToDelete,
            load_state,
            navPage,
            fields,
            corporatesSearch,
            selectCorporate,
            // selectedField,
            searchBy,
            searchOptions,
            search,
            clearSearch,
            showModal,
            closeModal,
            editModal,
            isModalVisible,
            editedItem,
            saveDetail,
            error

        }
    },
    computed: {
        ... mapState({
            // arrow functions can make the code very succinct!
            corporates: state => state.Corporate.corporates,
            searchBy: state => state.OSearch
            // meta: state => state.Corporate.meta,
        }),
        // navPage:{
        //     get(){
        //         return this.$store.state.Corporate.meta.page
        //     },
        //     set(page){
        //         const meta = {...this.meta,page}
        //         this.$store.commit('Corporate/switch_page',{meta})
        //     }
        // }
    },
    components:{
        OTable,
        OPagination,
        OBreadCrumb,
        OSearch,
        CorporateDetail,
        OWarningBox
    }
}
</script>

<style scoped>
    .form-group {
        width: 250px;
        text-align: left;
        padding-left: 16px;
    }
</style>